//get cookie
export function getCookie(cname: string): string | null {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

export function setCookie(name: string, value: string): void {
    if (window.location.href.indexOf('localhost:') >= 0) {
        document.cookie =
            name + '=' + value + '; path=/; expires=' + new Date(2147483647 * 1000).toUTCString();
    } else {
        document.cookie =
            name +
            '=' +
            value +
            '; path=/; secure; expires=' +
            new Date(2147483647 * 1000).toUTCString();
    }
}
